

export default function Experiencia () {
  return(
    <div className='bg-logistica bg-cover h-screen w-full flex flex-col items-center'>
      <h1 className="text-[4vw] text-[#333] mt-20">PÁGINA EN CONSTRUCCIÓN</h1>
      <h3 className="text-[2.5vw]">Estamos trabajando para brindarte el mejor servicio</h3>
    </div>
  )
}